export class InsufficientInputs {
    constructor(details) {
        this.message = `Insufficient inputs: ${details}`;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5zdWZmaWNpZW50SW5wdXRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2VyZ28vZXJyb3JzL2luc3VmZmljaWVudElucHV0cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLE9BQU8sa0JBQWtCO0lBRzdCLFlBQVksT0FBZTtRQUN6QixJQUFJLENBQUMsT0FBTyxHQUFHLHdCQUF3QixPQUFPLEVBQUUsQ0FBQTtJQUNsRCxDQUFDO0NBQ0YifQ==